import { render, staticRenderFns } from "./EmailVerificationCode.vue?vue&type=template&id=52afbe76&scoped=true"
import script from "./EmailVerificationCode.vue?vue&type=script&lang=js"
export * from "./EmailVerificationCode.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationCode.vue?vue&type=style&index=0&id=52afbe76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52afbe76",
  null
  
)

export default component.exports